import renderInputField from 'components/FormControls/textInput'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Field, reduxForm } from 'redux-form'
import shouldAsyncValidate from 'utils/shouldAsyncValidate'
import baseLoginValidator from 'utils/validators/baseLoginValidator'
import * as Yup from 'yup'
import LoginField from '../subcomponents/LoginField'
import { useAccountCreateFormSubmit } from 'modules/Forms/Account/Create/useAccountCreateFormSubmit'
import FormFrame from 'modules/Forms/Account/Create/subcomponents/FormFrame'
import clsx from 'clsx'
import formStyles from 'modules/Forms/common-form.module.scss'

export const SnapchatSchema = () =>
  Yup.object().shape({
    logins: Yup.array().of(Yup.object()),
    login: Yup.string().when('logins', ([logins], schema) =>
      logins
        ? schema.strip()
        : schema
            .test('baseLoginTest', '', baseLoginValidator)
            .required('common::validation_messages.required'),
    ),
    network: Yup.string().required('common::validation_messages.required'),
  })

let CreateSnapchatAccountForm = ({
  handleSubmit,
  submitting,
  onClose,
  form,
  autofill,
  networkId,
  array,
  multiLogins,
  networkType,
}) => {
  const { t } = useTranslation()
  const submitAccountData = useAccountCreateFormSubmit({ form, onClose, multiLogins, networkType })

  return (
    <FormFrame
      onSubmit={handleSubmit(submitAccountData)}
      multiLogins={multiLogins}
      form={form}
      submitAccountData={submitAccountData}
      submitting={submitting}
      onClose={onClose}
    >
        <Field
          disabled
          name="network"
          hidden
          fullWidth
          component={renderInputField}
          t={t}
        />

        <div className={clsx('margin-bottom-16', formStyles['row_with-tooltip'])}>
          <LoginField
            form={form}
            multiLogins={multiLogins}
            array={array}
            autofill={autofill}
            networkId={networkId}
            label={'services::forms.register_account.snapchat.fields.login.label'}
          />
        </div>

    </FormFrame>
  )
}

CreateSnapchatAccountForm = reduxForm({
  form: 'CreateSnapchatAccountForm',
  initialValues: {
    login: '',
    network: '',
  },
  shouldAsyncValidate: shouldAsyncValidate,
})(CreateSnapchatAccountForm)

CreateSnapchatAccountForm.propTypes = {
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  onClose: PropTypes.func,
  autofill: PropTypes.func,
  networkId: PropTypes.string,
  initialValues: PropTypes.object,
  form: PropTypes.string,
  multiLogins: PropTypes.bool,
  array: PropTypes.object,
  networkType: PropTypes.string,
}

export default CreateSnapchatAccountForm
